<template>
  <section class="page product">
    <div class="product__title" :class="{'not-loaded': notLoaded}">
      <AppTitle title="lof" size="medium"/>
    </div>
    <span class="product__separator" v-if="!isMobile"></span>
    <div class="product__content container" v-if="loadedContent">
      <div class="product__pictures">
        <template v-for="(item, index) in content.acf.gallery">
          <div :key="index" class="product__picture">
            <AppLazyImg :alt="item.image.alt" :url="item.image.url" :width="item.image.width" :height="item.image.height" :classes="['product__img']" />
            <p v-if="item.credit" class="product__picture__credit">Photo credits : {{ item.credit }}</p>
            <span v-if="!(index === content.acf.gallery.length - 1) && !isMobile" class="product__picture__separator"></span>
          </div>
        </template>
        <div class="product__infos__tags" v-if="isMobile">
          <p class="product__infos__tag--title">tags</p>
          <p class="product__infos__tag" v-for="(item, index) in tags" :key="index" @click="onClickTag(item)">{{ item.name }}<span v-if="index !== tags.length-1">,</span></p>
        </div>
      </div>
      <div class="product__infos">
        <div class="product__infos__description">
          <a class="product__link" :href="content.acf.link" target="_blank" rel="noopener"><span class="product__link__inner">link</span></a>
          <a class="product__link product__link--black" :href="content.acf.link" target="_blank" rel="noopener"><span class="product__link__inner">link</span></a>
          <h2 class="product__infos__title" v-html="content.acf.title"></h2>
          <p class="product__description" v-html="content.acf.description"></p>
          <p class="product__price">{{ content.acf.price }}</p>
        </div>
        <span class="product__infos__separator"></span>
        <div class="product__infos__tags" v-if="!isMobile">
          <p class="product__infos__tag--title">tags</p>
          <p class="product__infos__tag" v-for="(item, index) in tags" :key="index" @click="onClickTag(item)">{{ item.name }}<span v-if="index !== tags.length-1">,</span></p>
        </div>
      </div>
    </div>
    <span class="product__separator"></span>
    <nav class="product__nav-buttons" v-if="loadedContent" :class="navButtonsClasses">
      <router-link v-if="content.next" :to="`/product/${content.next.id}`" class="product__nav-buttons__prev">previous</router-link>
      <router-link v-if="content.previous" :to="`/product/${content.previous.id}`" class="product__nav-buttons__next">next</router-link>
    </nav>
    <span class="product__separator"></span>
    <div class="container">
      <div v-if="loadedContent && content.acf.related_products.length > 0" class="products__related-products">
        <AppRelated :query="bQuery" :isProducts="true" label="back to shop" :items="content.acf.related_products"/>
      </div>
    </div>
    <span class="product__separator"></span>
    <div class="container">
      <div v-if="loadedContent && content.acf.related_news.length > 0" class="products__related-news">
        <AppRelated :isProducts="false" label="see all news" :items="content.acf.related_news"/>
      </div>
    </div>
  </section>
</template>

<script>
  import Page from '@/mixins/Page'
  import API from '@/mixins/API'

  import AppTitle from '@/components/AppTitle.vue'
  import AppRelated from '@/components/AppRelated.vue'
  import AppLazyImg from '@/components/AppLazyImg.vue'

  import EventHub from '@/utils/EventHub'

  export default {
    name: 'Shop',

    mixins: [
        Page,
        API
    ],

    components: {
      AppTitle,
      AppRelated,
      AppLazyImg
    },

    data() {
      return {
        tags: [],
        bQuery: null
      }
    },

    computed: {
      navButtonsClasses()
      {
        return {
          'no-prev': !this.content.next,
          'no-next': !this.content.previous
        }
      }
    },

    beforeRouteEnter(to, from, next) 
    {
      next((vm) => {
        const bQuery = {}

        if('page' in to.query)
        {
          bQuery.page = to.query.page
        }
        if('col' in to.query)
        {
          bQuery.col = to.query.col
        }
        if('item' in to.query)
        {
          bQuery.item = to.query.item
        }

        if(Object.entries(bQuery).length > 0)
        {
          vm.bQuery = bQuery
          EventHub.$emit('header:set-back-query', bQuery)
        }

      })
    },

    created()
    {
      const endpoint = '/wp-json/wp/v2/products/' + this.$route.params.id
      
      this.addEventListeners()


      this.loadDatas(endpoint, (res) => {

        this.content = res


        if(this.content.acf.related_products.length > 0 || this.content.acf.related_news.length > 0)
        {
          this.getRelatedProductsAndNews()
        }
        else
        {
          this.onLoadedDatas()
        }

        EventHub.$emit('application:ask-for-tags')
      }, false)
    },

    destroyed()
    {
      this.removeEventListeners()
    },

    methods: {
      addEventListeners()
      {
        EventHub.$on('application:get-all-tags', this.onGetAllTags)
      },

      removeEventListeners()
      {
        EventHub.$off('application:get-all-tags', this.onGetAllTags)
      },

      getRelatedProductsAndNews()
      {
        const endpoints = []

        //related products
        for(let i = 0; i < this.content.acf.related_products.length; i++)
        {
          const endpoint = {
            path: ['related_products', i],
            url: `/wp-json/acf/v3/products/${this.content.acf.related_products[i].ID}`
          }
          endpoints.push(endpoint)
        }

        // related news
        for(let i = 0; i < this.content.acf.related_news.length; i++)
        {
          const endpoint = {
            path: ['related_news', i],
            url: `/wp-json/acf/v3/products/${this.content.acf.related_news[i].ID}`
          }
          endpoints.push(endpoint)
        }
        
        // Load all
        this.fetchMultipleUrls(endpoints, () => {
          this.onLoadedDatas()
        })

      },

      onGetAllTags(tags)
      {
        if(this.content && tags.length > 0)
        {
          for(let i = 0; i < this.content.tags.length; i++)
          {
            for(let j = 0; j < tags.length; j++)
            {
              if(this.content.tags[i] === tags[j].id)
              {
                this.tags.push(tags[j])
              }
            }
          }
        }
      },
      
      onClickTag(tag)
      {
        EventHub.$emit('application:toggle-tags-search', {value: tag.name, id: tag.id})
      }
    }
  }
</script>


<style lang="stylus">
  .product
    // padding-top 130px

    @media(max-width 768px)
      // padding-top 20px

  .product__title
    margin-bottom 60px
    // transform translateY(6vh)
    transform translate3d(0, 0px, 0)
    transition transform 1.2s $ease-in-out-circ 0s

    &.not-loaded
      transform translate3d(0, 50px, 0)
      transition transform 0s $ease-in-out-circ

      @media(max-width 768px)
        transform translate3d(0, 0px, 0)

    @media(max-width 768px)
      margin-bottom 45px
      padding-left $space-x-mobile
      // transform translateY(0)
      .title
        font-size 65px

  .product__separator
    width 100%
    height 1px
    display block
    background #a5a5a2

  .product__content
    width 100%
    display flex

    @media(max-width 768px)
      flex-direction column-reverse
      padding-bottom 20px

  .product__pictures, .product__infos
    position relative
    width 50%

    @media(max-width 768px)
      width 100%

  .product__pictures
    display flex
    flex-direction column
    border-right 1px solid #a5a5a2

    @media(max-width 768px)
      border-right none

  .product__picture
    position relative
    padding calc(100% / 36 * 2) calc(100% / 36 * 2) calc(100% / 36 * 2) 0

    @media(max-width 768px)
      padding 0
      margin-top 20px

  .product__picture__credit
    margin-top 25px
    line-height 1
    interpolate('font-size', 1600px, 2560px, 20px, 25px);

    @media(max-width 1600px)
      interpolate('font-size', 768px, 1600px, 13px, 20px);

  .product__picture__separator
    position absolute
    bottom 0
    right 0
    width 50vw
    height 1px
    display block
    background #a5a5a2

  .product__img
    width 100%
    display block

  .product__infos__description
    position relative
    padding-left calc(100% / 36 * 2)
    padding-bottom calc(100% / 36 * 2)

    @media(max-width 768px)
      padding 0

  .product__link
    cursor pointer
    position absolute
    right - $space-x
    height 92px
    width 150px
    display block
    line-height 92px
    text-align center
    text-transform uppercase
    border-left 1px solid #a5a5a2
    border-bottom 1px solid #a5a5a2
    interpolate('font-size', 1600px, 2560px, 30px, 40px);

    @media(max-width 1600px)
        interpolate('font-size', 768px, 1600px, 15px, 30px);

    @media(max-width 768px)
      right -1 * $space-x-mobile
      bottom -20px
      border-top 1px solid $black
      border-left 1px solid $black
      border-bottom none
      font-size 20px
      height 62px
      line-height 62px
      width 120px

  .product__link--black
    background-color $black
    color $white
    opacity 0
    transition opacity 0.1s $ease-out-quad

    &:hover
      opacity 1

  .product__link__inner
    opacity 1
    transition opacity 0.5s $ease-out-circ

  .product__infos__title
    max-width 70%
    padding-top 92px
    margin-bottom 30px
    text-transform uppercase
    line-height 1
    interpolate('font-size', 1600px, 2560px, 60px, 84px);

    @media(max-width 1600px)
      interpolate('font-size', 768px, 1600px, 30px, 60px);

    @media(max-width 768px)
      width calc(100% / 16 * 14)
      max-width 100%
      padding-top 0
      font-size 32px

  .product__description
    max-width 70%
    margin-bottom 50px
    line-height 1.5
    interpolate('font-size', 1600px, 2560px, 30px, 40px);

    @media(max-width 1600px)
        interpolate('font-size', 768px, 1600px, 15px, 30px);

    @media(max-width 1400px)
      max-width 85%

    @media(max-width 768px)
      width calc(100% / 16 * 14)
      max-width 100%
      margin-bottom 60px
      font-size 17px

  .product__price
    text-transform uppercase
    line-height 1;
    // $font-medium-paragraph-large;
    interpolate('font-size', 1600px, 2560px, 42px, 72px);

    @media(max-width: 1600px)
      // $font-medium-paragraph-medium;
      interpolate('font-size', 768px, 2560px, 32px, 42px);

    @media(max-width 768px)
      margin-bottom 20px

  .product__infos__separator
    position absolute
    left 0
    width 50vw
    height 1px
    display block
    background #a5a5a2

    @media(max-width 768px)
      width 100vw
      left -1 * $space-x-mobile
      background $black

  .products__related-products, .products__related-news
    width calc(100% / 36 * 22)
    margin-right auto 
    margin-left auto
    // margin 120px auto 100px auto

    @media(max-width 768px)
      width 100%
      // margin 60px auto 60px auto

  .products__related-products
    interpolate('margin-top', 768px, 2560px, 135px, 410px);
    interpolate('margin-bottom', 768px, 2560px, 70px, 200px);

    @media(max-width 768px)
      margin 60px auto 60px auto
  
  .products__related-news
    interpolate('margin-top', 768px, 2560px, 75px, 215px);
    interpolate('margin-bottom', 768px, 2560px, 70px, 200px);

    @media(max-width 768px)
      margin 60px auto 60px auto
      
    .related__items
      @media(max-width 768px)
        margin-bottom 20px

  .product__infos__tags
    padding-top 60px
    padding-left calc(100% / 36 * 2)
    display flex
    flex-wrap wrap
    line-height 1.5
    interpolate('font-size', 1600px, 2560px, 30px, 40px);

    @media(max-width 1600px)
        interpolate('font-size', 768px, 1600px, 15px, 30px);

    @media(max-width 768px)
      padding-bottom 60px
      padding-left 0

  .product__infos__tag--title
    text-transform uppercase
    margin-right 30px

  .product__infos__tag
    cursor pointer
    text-transform lowercase
    border-bottom 2px solid $black
    margin-right 10px
    margin-bottom 10px

  .product__nav-buttons
    width 100%
    display flex
    text-transform uppercase
    justify-content space-between
    align-items center
    interpolate('padding-left', 768px, 2560px, 35px, 110px);
    interpolate('padding-right', 768px, 2560px, 35px, 110px);
    interpolate('height', 768px, 2560px, 200px, 525px);
    interpolate('font-size', 1600px, 2560px, 60px, 84px);

    @media(max-width 1600px)
      interpolate('font-size', 768px, 1600px, 30px, 60px);

    &.no-prev
      justify-content flex-end

    &.no-next
      justify-content flex-start

  .product__nav-buttons__next
    padding-right 16px

</style>
